var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activeMerchant
    ? _c(
        "div",
        { staticClass: "item logo" },
        [
          _c("div", { staticClass: "merchant" }, [
            _vm.activeMerchant.logo
              ? _c("div", { staticClass: "ui logo image" }, [
                  _c("img", {
                    attrs: { src: _vm.activeMerchant.logo, alt: "logo" }
                  })
                ])
              : _c("div", { staticClass: "ui small logo image" }, [
                  _c("img", { attrs: { src: _vm.defaultAvatar, alt: "logo" } })
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "zw header" }, [
              _vm._v(
                "\n\t\t\t\t" + _vm._s(_vm.activeMerchant.name) + "\n\t\t\t"
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "zw merchant info" }, [
            _c("div", { staticClass: "info-piece trigger" }, [
              _vm._v(_vm._s(_vm.$t("sidebar.merchant.phone")) + ": "),
              _c("strong", [_vm._v(_vm._s(_vm.activeMerchant.phone))])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showPiece,
                    expression: "showPiece"
                  }
                ],
                staticClass: "info-piece"
              },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      href: "http://maps.google.com/?q=" + _vm.merchantAddress
                    }
                  },
                  [_vm._v(_vm._s(_vm.merchantAddress))]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showPiece,
                    expression: "showPiece"
                  }
                ],
                staticClass: "info-piece"
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("sidebar.merchant.vat")) +
                    ": " +
                    _vm._s(_vm.activeMerchant.vat)
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showPiece,
                    expression: "showPiece"
                  }
                ],
                staticClass: "info-piece",
                staticStyle: {
                  "word-break": "break-all",
                  "text-transform": "none"
                }
              },
              [
                _vm._v(_vm._s(_vm.$t("sidebar.merchant.email")) + ": "),
                _c(
                  "a",
                  { attrs: { href: "mailto:" + _vm.activeMerchant.email } },
                  [_vm._v(_vm._s(_vm.activeMerchant.email))]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showPiece,
                    expression: "showPiece"
                  }
                ],
                staticClass: "info-piece"
              },
              [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.showTermsModal = true
                      }
                    }
                  },
                  [_vm._v("Handelsbetingelser")]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "ui bottom attached icon button",
                on: {
                  click: function($event) {
                    return _vm.toggleShowPiece()
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "angle double icon",
                  class: { up: _vm.showPiece, down: !_vm.showPiece }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "semantic-modal",
            {
              ref: "payment_terms",
              attrs: {
                settings: {
                  content_classes: { content: true },
                  closeable: false,
                  closeable_button: false
                }
              },
              model: {
                value: _vm.showTermsModal,
                callback: function($$v) {
                  _vm.showTermsModal = $$v
                },
                expression: "showTermsModal"
              }
            },
            [
              _c("payment-terms"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "actions",
                  attrs: { slot: "actions" },
                  slot: "actions"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "ui red button",
                      on: {
                        click: function($event) {
                          return _vm.closeTermsModal()
                        }
                      }
                    },
                    [_vm._v("Close")]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36f1bdcc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36f1bdcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/MerchantProfile.vue
// module id = FSBk
// module chunks = 1